type EmojisType = {
  [key: string]: string;
};

let emojis: EmojisType = {}; //['☺', '☹', '♫', '☂', '☻', '☀', '❄', '☃', '♥', '♡', '☕'];
export const phrases = ['gl', 'brb', 'Have a good day!', 'Nice hand!', 'Thank you', 'TY for playing', 'TY for waiting'];
export const spanishPhrases = ['que tengas un buen día', 'Muchas Gracias', 'Gracias por jugar!'];

function registerEmoji(similarStr: string, symbol: string) {
  emojis[similarStr] = symbol;
}

// В порядке приоритета замены (первые приоритетнее)
registerEmoji(':D', '😁'); // 1F601
registerEmoji(';)', '😉'); // 1F609
registerEmoji('☺♥', '😍'); // 1F60D
registerEmoji('☺', '😊'); // 1F60A
registerEmoji(':^,', '😏'); // 1F60F
registerEmoji(':*(', '😭'); // 1F62D
registerEmoji(':*', '😘'); // 1F618
registerEmoji(';P', '😜'); // 1F61C
registerEmoji('☹', '😞'); // 1F61E
registerEmoji('X(', '😠'); // 1F620
registerEmoji(':-T', '😡'); // 1F621
registerEmoji(":'(", '😢'); // 1F622

export function emojiTemplate(fromSimilar: boolean) {
  let tpl = '';

  for (let similarStr in emojis) {
    if (!emojis.hasOwnProperty(similarStr)) continue;
    if (tpl !== '') tpl += '|';
    tpl += '(';
    // eslint-disable-next-line
    if (fromSimilar) tpl += similarStr.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    // eslint-disable-next-line
    else tpl += emojis[similarStr].replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    tpl += ')';
  }
  return '(' + tpl + ')';
}

export function emojiFromSimilar(text: string) {
  var regEx = new RegExp(emojiTemplate(true), 'ig');
  return text.replace(regEx, function (str) {
    return emojis[str];
  });
}

export function emojiToSimilar(text: string) {
  const similar = objectFlip(emojis);
  const regEx = new RegExp(emojiTemplate(false), 'ig');
  return text.replace(regEx, function (str) {
    return similar[str];
  });
}

function objectFlip(obj: EmojisType): EmojisType {
  return Object.keys(obj).reduce((ret: EmojisType, key) => {
    ret[obj[key]] = key;
    return ret;
  }, {});
}
